<!-- #166 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Fulfillment Inventory ledger list
      </div>
      <v-spacer></v-spacer>
      <v-col
        md="3"
        class="d-flex text-end pt-0 pb-0"
        v-if="userCategory.user_category === 3"
      >
        <v-autocomplete
          v-model="selectedClient"
          :items="clients"
          @input="fetchList"
          :loading="clientLoader"
          hide-no-data
          hide-details
          item-text="name"
          item-value="id"
          label="Client Name"
          class="pb-0 pl-3 pt-0 text-center mt-0 required"
          :rules="[(v) => !!v || 'Please select client']"
          return-object
          @focus="fetchClientList"
        ></v-autocomplete>
      </v-col>
    </div>
    <v-divider class="mt-0 mb-2"></v-divider>
    <v-app>
      <v-data-table
        :headers="_headers"
        :items="list"
        :options.sync="options"
        :server-items-length="total"
        :loading="loader"
        class="elevation-1 mt-2"
        :footer-props="{
          itemsPerPageOptions: [25, 50, 100, 250],
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:top>
          <template>
            <div class="custom-row p-5">
              <v-spacer v-if="userCategory.user_category != 1"></v-spacer>
              <v-col cols="12" sm="3" v-if="selectedClient">
                <v-text-field label="Sku" v-model="sku" outlined></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" v-if="userCategory.user_category === 1">
                <v-text-field label="Sku" v-model="sku" outlined></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="selectedClient || userCategory.user_category === 1"
              >
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      class="custom-padding"
                      outlined
                      @click:clear="clearDateInput('from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="selectedClient || userCategory.user_category === 1"
              >
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" class="mt-4" v-if="selectedClient">
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>

              <v-col
                cols="12"
                sm="3"
                class="mt-4"
                v-if="userCategory.user_category === 1"
              >
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
            <v-divider
              class="mb-2"
              v-if="selectedClient || userCategory.user_category === 1"
            ></v-divider>
          </template>
        </template>
        <template v-slot:item.oms_date="{ item }">
          {{ item.oms_date | uaeDateTime | moment("DD MMM, YYYY") }}
        </template>
        <template v-slot:item.opening_balance="{ item }">
          {{ changeFormat(item.opening_balance) }}
        </template>
        <template v-slot:item.closing_balance="{ item }">
          {{ changeFormat(item.closing_balance) }}
        </template>
      </v-data-table>
    </v-app>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userCategory"]),
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "client_name"
          : true;
      });
    },
  },
  mounted() {
    this.fetchClientList();
  },
  data() {
    return {
      page: "listPage",
      options: {},
      packages: [],
      clients: [],
      selectedClient: null,
      total: 0,
      loader: false,
      dateMenuTo: false,
      dateMenu: false,
      from_date: null,
      to_date: null,
      headers: [
        {
          text: "Client",
          value: "client_name",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Sku",
          value: "sku_code",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Date",
          value: "oms_date",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Opening Balance",
          value: "opening_balance",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Closing Stock",
          value: "closing_balance",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.allFilters();
        this.fetchList();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(["fetchClient", "getInventoryLedgerList"]),
    callFunc() {
      this.loader = true;
      this.getInventoryLedgerList({
        ...this.options,
        ...this.selectedClient,
        ...this.filtersArr,
      })
        .then((res) => {
          this.list = res.data.records;
          this.total = res.data.total;
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
          this.list = [];
        });
    },
    fetchList() {
      if (this.userCategory.user_category === 3) {
        if (this.selectedClient !== undefined && this.selectedClient !== null) {
          this.callFunc();
        }
      } else if (this.userCategory.user_category === 1) {
        this.callFunc();
      }
    },
    clearDateInput(from) {
      if (from == "to_date") {
        this.to_date = null;
      } else {
        this.from_date = null;
      }
    },
    clearAll() {
      this.filtersArr = [];
      this.sku = null;
      this.from_date = null;
      this.to_date = null;
      this.fetchList();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        sku_code: this.sku,
        from_date: this.from_date,
        to_date: this.to_date,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getInventoryLedgerList({
        ...this.options,
        ...this.filtersArr,
        ...this.selectedClient,
      })
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    fetchClientList() {
      if (this.clients.length) return;
      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;
        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "fulfillment_wid_last_mile,fulfillment",
          active: "True",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
  },
};
</script>
<style>
.file-padding {
  padding-right: 72px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
/* .v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input {
  padding-top: 25px !important;
} */

.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  display: flex;
  flex: 1 1 auto;
  position: relative;
  padding-top: 9px !important;
}
</style>
